import { useContext, useCallback } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';

const SendReworkButton = ({ order }) => {
  const { hasPermissions, hasRoles } = useContext(AuthContext);

  const hasViewButton = useCallback(() => {
    // Sem setor de destino (ex.: 'Em inclusão' ou 'Arquivado'), nao ha para onde
    // enviar retrabalho — esconde o botao para todos os perfis, inclusive admin/master.
    const hasReworkDestination =
      order.possible_rework_sections &&
      order.possible_rework_sections.length > 0;

    if (!hasReworkDestination) return false;

    if (
      hasPermissions(['add_order']) &&
      /Recebido na unidade|Entregue/.test(order.order_status)
    ) {
      return true;
    }
    if (
      hasPermissions(['print_photos']) &&
      /Em impressão|Em plotter/.test(order.order_status)
    ) {
      return true;
    }
    // Montagem pega o pedido em 'Impresso'/'Plotado' — se a peça chegou com
    // defeito, devolve para Impressão/Plotter dali mesmo (ajuste 05/07).
    if (
      hasPermissions(['assemble_order']) &&
      /Impresso|Plotado|Em montagem/.test(order.order_status)
    ) {
      return true;
    }

    // Plotter puro: devolve para a Impressão se o material chegou ruim
    // ('Impresso' aguardando plotter ou durante 'Em plotter').
    if (
      hasPermissions(['plotter_photos']) &&
      /Impresso|Em plotter/.test(order.order_status)
    ) {
      return true;
    }

    if (
      hasPermissions(['pack_order']) &&
      /Em embalagem|Embalado|Em expedição/.test(order.order_status)
    ) {
      return true;
    }
    // FEAT-015: o EDITOR pode devolver durante a edição (ex.: faltam fotos
    // capturadas -> retrabalho para o Comercial completar).
    if (
      hasPermissions(['edit_photos']) &&
      /Em edição/.test(order.order_status)
    ) {
      return true;
    }
    // DECISÃO DE NEGÓCIO (26/06/2026): Inspetor (edit_inspection) e Vendedor (seller_inspection)
    // podem enviar retrabalho em QUALQUER status, exceto 'Arquivado'. Os setores de destino são
    // limitados pelo backend aos JÁ PERCORRIDOS pelo pedido (possible_rework_sections).
    if (
      hasPermissions(['edit_inspection', 'seller_inspection']) &&
      !/Arquivado/.test(order.order_status)
    ) {
      return true;
    }
    if (hasRoles(['administrator', 'master'])) return true;

    return false;
  }, [order]);

  return (
    <>
      {hasViewButton() && (
        <div className="col-sm col-md-4 col-xl-3 mt-2">
          <button
            className="btn btn-danger btn-block col-12"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#modal-rework-order"
          >
            enviar retrabalho
          </button>
        </div>
      )}
    </>
  );
};

SendReworkButton.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
    is_rework: PropTypes.bool,
    possible_rework_sections: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default SendReworkButton;
